/* Audit Logs API calls (read-only). Everything goes through axiosInstance via
   api/methods so the Bearer token is attached. The backend wraps responses in
   { status, message, data }; we unwrap `.data.data`. */

import { get } from "../../api/methods";
import { filtersToQueryString } from "./auditLogsUtils";

/** GET /audit-logs -> { items, total, page, limit }. Errors are re-thrown as-is
 *  so the page can read `error.response.status` (422 date message, 403, ...). */
export const listAuditLogs = async (filters) => {
  const res = await get(`/audit-logs?${filtersToQueryString(filters)}`);
  // axiosInstance turns a permission 403 on a GET into a resolved empty
  // payload; surface it as a real 403 so the page shows "no access".
  if (res?.permissionDenied) {
    const err = new Error(res?.data?.message || "You don't have access to audit logs");
    err.response = { status: 403, data: res.data };
    throw err;
  }
  const data = res?.data?.data || {};
  return {
    items: Array.isArray(data.items) ? data.items : [],
    total: Number(data.total) || 0,
    page: Number(data.page) || filters.page || 1,
    limit: Number(data.limit) || filters.limit,
  };
};

/** GET /audit-logs/meta -> { actions, modules } or null if unavailable. */
export const getAuditLogMeta = async () => {
  try {
    const res = await get("/audit-logs/meta");
    const data = res?.data?.data;
    if (data && Array.isArray(data.actions) && Array.isArray(data.modules)) return data;
  } catch {
    /* fall back to the built-in lists */
  }
  return null;
};

/** GET /audit-logs/export -> CSV Blob (same filters, no paging). */
export const exportAuditLogs = async (filters) => {
  const res = await get(`/audit-logs/export?${filtersToQueryString(filters, { withPaging: false })}`, {
    responseType: "blob",
  });
  return res.data;
};
